import { Vector2Tuple } from 'three';

import { FAreaShallowNode } from '@spazious/dollhouse-shallow-graph';

import { FAreaNode, FNodeTypesEnum } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class FAreaNodeImpl extends BaseNodeImpl implements FAreaNode {
  type: FNodeTypesEnum.FArea = FNodeTypesEnum.FArea;
  shallow: FAreaShallowNode | null = null;
  points: Vector2Tuple[] = [];
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  visible: boolean = true;
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      position: this.position,
      rotation: this.rotation,
      visible: this.visible,
      shallow: this.shallow,
      points: this.points,
    };
  }
}
